import { doc, DocumentReference, serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore'
import leaveRequestServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { LeaveRequest, LeaveRequestRaw } from '../../database/tables'
import DateHelper from '../../helpers/date-helper'

export type UpdateLeaveRequestByIdParams = {
  id: string
  data: Partial<
    Omit<
      LeaveRequest,
      | 'id'
      | 'approvalStatus'
      | 'createdAt'
      | 'updatedAt'
      | 'updatedBy'
      | 'approvalUpdatedAt'
      | 'approvalBy'
      | 'supportingDocumentRef'
      | 'supportingDocumentUrl'
    >
  >
  updatedBy: string | null
}

export default async function updateLeaveRequestById(params: UpdateLeaveRequestByIdParams): Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(db, leaveRequestServiceConfigs.collectionName, params.id) as DocumentReference<LeaveRequestRaw>

      let newStartDate: { date: Timestamp; stringDate: string } | undefined = undefined
      let newEndDate: { date: Timestamp; stringDate: string } | undefined = undefined

      if (!!params.data.startDate) {
        newStartDate = {
          date: Timestamp.fromDate(DateHelper.toUTCMidnight(params.data.startDate)),
          stringDate: DateHelper.toLocalDateString(params.data.startDate),
        }
      }
      if (!!params.data.endDate) {
        newEndDate = {
          date: Timestamp.fromDate(DateHelper.toUTCMidnight(params.data.endDate)),
          stringDate: DateHelper.toLocalDateString(params.data.endDate),
        }
      }

      await updateDoc(docRef, {
        ...params.data,
        startDate: newStartDate?.date ?? undefined,
        startDateString: newStartDate?.stringDate ?? undefined,
        endDate: newEndDate?.date ?? undefined,
        endDateString: newEndDate?.stringDate ?? undefined,
        updatedBy: params.updatedBy,
        updatedAt: serverTimestamp(),
      })

      return resolve()
    } catch (e) {
      return reject(e)
    }
  })
}
